import {
  GET_CRM_ENQUIRY,
  GET_CRM_ENQUIRY_SOURCE,
  GET_CUSTOMER_BUDGET,
  GET_CRM_DIMENSION,
  GET_CUSTOMER_CONSTRUCTIONS_PLANNING,
  GET_CUSTOMER_PURCHASE_REASON,
  GET_CRM_SITE_SOLD,
  GET_CRM_CUSTOMER_ENQUIRY,
  GET_CRM_ENQUIRY_PROFILE,
  GET_CRM_ENQUIRY_PROFILE_EXPORT,
  GET_SITE_VISIT_FEEDBACK_QUESTION,
  GET_SITE_VISIT_FEEDBACK,
  GET_SITE_VISIT_FEEDBACK_EXPORT,
  GET_SITE_VISIT_FEEDBACK_DETAIL,
  GET_CRM_BOOKING_ENQUIRY_PROFILE,
  GET_CRM_MEETING,
  GET_CRM_MEETING_CATEGORY,
  GET_CRM_MEETING_ATTENDEE,
  GET_CRM_MEETING_DETAIL,
  GET_CRM_MEETING_EXPORT,
  GET_CRM_MEETING_SOURCE,
  GET_CRM_MEETING_CHANNEL_PARTNER_INFO,
  GET_CRM_MEETING_CHANNEL_CLIENT_INFO,
  GET_CRM_MEETING_PREFERRED_LOCATION,
  GET_CRM_MEETING_PREFERRED_LOCATION_EXPORT,
  GET_CRM_MEETING_STM_INFO,
  GET_CRM_SOURCE_GROUP,
  GET_CRM_SOURCE_GROUP_EXPORT,
  GET_CRM_SOURCE_CATEGORY,
  GET_CRM_SOURCE,
  GET_CRM_ENQUIRY_STATUS,
  GET_CRM_ENQUIRY_CALL_STATUS,
  GET_CRM_ENQUIRY_CATEGORY,
  GET_DIMENSION_MASTER,
  GET_RELEASE_STATUS,
  GET_CRM_SITE_PREMIUM_TYPE,
  GET_CRM_SITE_STATUS,
  GET_SITE_INVESTOR,
  GET_BLOCK_REASON,
  GET_ENQUIRY_FOLLOW_STATUS,
  GET_CRM_CHANNEL_PARTNER,
  GET_CRM_CLIENT,
  GET_CRM_STM,
  GET_CRM_MEETING_FILTER_PROJECT,
  GET_CRM_MEETING_FILTER_HOSTED_BY,
  GET_FELLOW_UP,
  GET_FELLOW_UP_EXPORT,
  GET_CRM_FOLLOW_UP_FILTER_ASSIGNED_TO,
  GET_CRM_ENQUIRY_FOLLOW_UP_REASON,
  GET_CRM_SITE_FACE,
  GET_CRM_CANCELLATION_REASON,
  GET_PROMOTIONAL_ACTIVITY,
  GET_PROMOTIONAL_ACTIVITY_FILTER_PROJECT,
  CHECK_EXISTING_ENQUIRY,
  GET_ACTIVITY_FOR_PROMOTIONAL_LEAD,
  GET_PROMOTIONAL_LEAD,
  GET_PROMOTIONAL_LEAD_EXPORT,
  GET_PROMOTIONAL_LEAD_FILTER_PROJECT,
  GET_PROMOTIONAL_LEAD_FILTER_SOURCE,
  GET_PROMOTIONAL_LEAD_FILTER_ACTIVITY,
  GET_SOURCE_FOR_PROMOTIONAL_LEAD,
  GET_USER_FOR_PROMOTIONAL_LEAD,
  GET_ENQUIRY_DETAIL_FOR_PROMOTIONAL_LEAD,
  GET_LEAD_FOR_SITE_VISIT,
  GET_LEAD_DETAIL_FOR_SITE_VISIT,
  GET_SITE_VISIT,
  GET_EOI_PRICE,
  GET_EOI_PRICE_FILTER_PROJECT,
  GET_EXPRESSION_OF_INTEREST,
  GET_EXPRESSION_OF_INTEREST_EXPORT,
  GET_EOI_PRICE_FILTER_DIMENSION,
  GET_CUSTOMER_INFO,
  GET_EXPRESSION_OF_INTEREST_DETAIL,
  GET_EXPRESSION_OF_INTEREST_FILTER_PROJECT,
  GET_EOI_PRICE_DETAIL,
  GET_SITE_FACING,
  GET_EOI_PAYMENT_DETAIL,
  GET_COMPANY_FOR_CRM_PROJECT,
  GET_CUSTOMER_TICKET,
  GET_USER_TICKET_FILTER,
  GET_CUSTOMER_TICKET_EXPORT,
  GET_TICKET_FOLLOW_UP,
  GET_CUSTOMER_TICKET_DETAIL,
  GET_PROJECT_TICKET_FILTER,
  GET_CUSTOMER_TICKET_STATUS,
  //CustomerTicketCategory
  GET_CUSTOMER_TICKET_CATEGORY,
  GET_CUSTOMER_TICKET_CATEGORY_EXPORT,
  GET_CUSTOMER_TICKET_FILTER_STATUS,
  GET_CUSTOMER_TICKET_FOR_ASSINGNED_USER,
  GET_CUSTOMER_TICKET_FOR_SITE,
  //Site Visit
  GET_SITE_VISIT_COMPLETED,
  GET_SITE_VISIT_COMPLETED_FILTER_PROJECT,
  GET_ITEM_FOR_TRAVEL_BILL,
  GET_TRAVEL_BILL_DETAILS,
  GET_SUB_SOURCE_FOR_PROMOTIONAL_LEAD,
  GET_COUNTRY_CODE,

  //CRM Masters
  //project premium cost
  GET_SITE_PREMIUM_TYPE,
  GET_SITE_PREMIUM_TYPE_EXPORT,
  GET_PROJECT_PREMIUM_COST,
  GET_PROJECT_PREMIUM_COST_EXPORT,
  GET_PROJECT_PREMIUM_COST_FILTER_PROJECT,
  GET_PROJECT_PREMIUM_COST_FILTER_PREMIUM_TYPE,
  //Readiness Checklist
  GET_READINESS_CHECKLIST,
  GET_READINESS_CHECKLIST_EXPORT,
  //Site Investor
  GET_SITE_INVESTORS,
  //Delay Reason
  GET_DELAY_REASON,
  GET_SITE_INVESTORS_EXPORT,
  GET_DELAY_REASON_EXPORT,
  //Site TDS
  GET_SITE_TDS,
  CREATE_SITE_TDS,
  UPDATE_SITE_TDS,
  GET_SITE_TDS_EXPORT,
  GET_SITE_TDS_DETAIL,
  GET_SITE_TDS_FILTER_SECTION,
  GET_TDS_SECTION,
  // site cost
  GET_SITE_COST,
  GET_SITE_COST_EXPORT,
  GET_SITE_COST_FILTER_PROJECT,
  //Registration Cost
  GET_REGISTRATION_COST,
  GET_REGISTRATION_COST_EXPORT,
  //sushil start
  GET_SOURCE_CATEGORY,
  GET_SOURCE_CATEGORY_EXPORT,
  GET_SOURCE,
  GET_SOURCE_EXPORT,
  GET_SUB_SOURCE,
  GET_SUB_SOURCE_EXPORT,
  GET_REASON,
  GET_REASON_EXPORT,
  GET_DIMENSION,
  GET_DIMENSION_EXPORT,
  GET_SITE_FACE,
  GET_SITE_FACE_EXPORT,
  GET_LEAD_STATUS,
  GET_LEAD_STATUS_EXPORT,
  GET_SITE_STATUS,
  GET_SITE_STATUS_EXPORT,
  GET_RELEASE_STATUS_NEW,
  GET_RELEASE_STATUS_NEW_EXPORT,
  GET_CANCELLATION_REASON,
  GET_CANCELLATION_REASON_EXPORT,
  GET_BLOCK_REASON_NEW,
  GET_BLOCK_REASON_NEW_EXPORT,
  GET_OTHER_CHARGES,
  GET_OTHER_CHARGES_EXPORT,
  GET_PROJECT_OTHER_CHARGE_MAP,
  GET_PROJECT_OTHER_CHARGE_MAP_EXPORT,
  GET_PROJECT_OTHER_CHARGE_DETAIL,
  GET_PROJECT_OTHER_CHARGE_DETAIL_FILTER_PROJECT,
  GET_CALL_STATUS,
  GET_CALL_STATUS_EXPORT,
  GET_UNQUALIFIED_REASON,
  GET_UNQUALIFIED_REASON_EXPORT,
  GET_SITE_DISCOUNT,
  GET_SITE_DISCOUNT_EXPORT,
  GET_CATEGORY_FOR_TICKET,
  GET_LEAD_CATEGORY,
  GET_LEAD_CATEGORY_EXPORT,
  GET_CRM_LEAD_CONSTRAINT,
  GET_CRM_LEAD_CONSTRAINT_EXPORT,
  GET_CUSTOMER_CONTACT_TYPE,
  GET_CUSTOMER_CONTACT_TYPE_EXPORT,
  GET_CUSTOMER_CONTACT,
  GET_CUSTOMER_CONTACT_EXPORT,
  GET_CUSTOMER_CONTACT_FILTER_PROJECT,
  GET_CUSTOMER_CONTACT_FILTER_CONTACT_TYPE,
  GET_CUSTOMER_FEEDBACK_FILTER_PROJECT,
  GET_CUSTOMER_FEEDBACK_EXPORT,
  GET_CUSTOMER_FEEDBACK,
  GET_PROJECT_PROGRESS,
  GET_PROJECT_PROGRESS_EXPORT,
  GET_PROJECT_PROGRESS_FILTER_PROJECT,
  GET_PROJECT_PROGRESS_DETAIL,
  //sushil end
  // clp start
  GET_CONSTRUCTION_LINK_PAYMENT,
  GET_CONSTRUCTION_LINK_PAYMENT_EXPORT,
  GET_PROJECT_CLP_PLAN,
  GET_PROJECT_CLP_PLAN_EXPORT,
  GET_PROJECT_CLP_PLAN_DETAILS,
  GET_PROJECT_CLP_PLAN_FILTER_PROJECT,
  GET_PROJECT_CLP_PLAN_FILTER_BANK,
  GET_PROJECT_FROM_CLP_PLAN,
  GET_BANK_FROM_CLP_PLAN,
  GET_MILESTONE_FORM_CLP_PLAN,
  //clp payment schedule
  GET_CLP_PAYMENT_SCHEDULE,
  GET_CLP_PAYMENT_SCHEDULE_EXPORT,
  GET_CLP_PAYMENT_SCHEDULE_FILTER_PROJECT,
  GET_CLP_PAYMENT_SCHEDULE_FILTER_STATUS,
  GET_CLP_PAYMENT_SCHUDULE_DETAIL,
  GET_CLP_PAYMENT_SCHEDULE_FILTER_SITE,
  GET_ITEM_FOR_PROJECR_PLAN_CLP,
  // clp demand
  GET_PROJECT_FOR_CLP_PLAN,
  GET_SITE_FOR_CLP_PLAN,
  GET_MILESTONE_FOR_DEMAND_NOTE,
  GET_CLP_DEMAND_NOTE,
  GET_CLP_DEMAND_NOTE_EXPORT,
  GET_PROJECT_FOR_CLP_DEMAND_NOTE,
  GET_CLP_DEMAND_NOTE_FILTER_STATUS,
  GET_CLP_DEMAND_NOTE_DETAILS,
  GET_PAYMENT_DELAY_REASON,
  GET_PAYMENT_RECEIPT_PRINT,
  GET_PAYMENT_DEMAND_FILTER_MILESTONE,
  GET_MILESTONE_FOR_DEMAND_NOTE_RECEIVED,
  GET_PAYMENT_DEMAND_FILTER_CRM_USER,
  GET_PAYMENT_DEMAND_FILTER_SITE_NUMBER,
  GET_PAYMENT_DEMAND_FILTER_SITE_STATUS,
  GET_PAYMENT_SCHEDULE_FILTER_CRM_USER,
  //Company Resolution
  GET_PROJECT_FOR_COMPANY_RESOLUTION,
  GET_COMPANY_RESOLUTION,
  GET_COMPANY_RESOLUTION_DETAIL,
  GET_COMPANY_RESOLUTION_FILTER_PROJECT,
  GET_COMPANY_RESOLUTION_FILTER_COMPANY,
  //site authority
  GET_SITE_FOR_COMPANY_AUTHORIZATION,
  GET_REPRESENTATIVE_FOR_COMPANY_AUTHORIZATION,
  GET_DIRECTOR_FOR_COMPANY_AUTHORIZATION,
  GET_COMPANY_AUTHORIZATION,
  GET_COMPANY_AUTHORIZATION_FILTER_PROJECT,
  GET_COMPANY_AUTHORIZATION_FILTER_COMPANY,
  GET_COMPANY_AUTHORIZATION_FILTER_DIRECTOR,
  GET_COMPANY_AUTHORIZATION_FILTER_REPRESENTATIVE,
  GET_COMPANY_AUTHORIZATION_DETAIL,
  GET_DIRECTOR_FOR_COMPANY_RESOLUTION
} from "./types";

const initialState = {
  getCrmEnquiry: [],
  getCrmEnquirySource: [],
  getCustomerBudget: [],
  getCustomerConstructionPlanning: [],
  getCustomerPurchaseReason: [],
  getCrmSiteSold: [],
  getCrmCustomerEnquiry: [],
  getCrmEnquiryProfile: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmEnquiryProfileExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteVisitFeedbackQuestion: [],
  getSiteVisitFeedback: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteVisitFeedbackExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteVisitFeedbackDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBookingEnquiryProfile: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeeting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingAttendee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingChannelPartnerInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingClientInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmPreferredLocation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmPreferredLocationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingStmInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSourceGroup: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSourceGroupExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCrmSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmEnquiryStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCrmEnquiryCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmEnquiryCallStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmDimensionMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmReleaseStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSitePremiumType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSiteStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSiteInvestor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmBlockReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEnquiryFollowStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingChannelPartner: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingClient: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingFilterHostedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmMeetingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFellowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFellowUpExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmFollowUpFilterAssignedTo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //CRM Demsion
  getCrmDimension: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmEnquiryFollowUpReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSiteFace: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmCancellationReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //promotional activity
  getPromotionalActivity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalActivityFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  checkExistingEnquiry: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getActivityForPromotionalLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalLeadExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalLeadFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalLeadFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPromotionalLeadFilterActivity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceForPromotionLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSubSourceForPromotionalLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserForPromotionalLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEnquiryDetailForPromotionalLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //site visit
  getLeadForSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadDetailForSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSitevisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEoiPrice: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getEoiPriceFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpressionOfInterest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpressionOfInterestExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEoiPriceFilterDimension: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpressionOfInterestDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getExpressionOfInterestFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEoiPriceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyForCrmProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEOIPaymentDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteFacing: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Customer Ticket
  getCategoryForTicket: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicket: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketForSite: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketFilterAssignedTo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketForAssignedUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTicketFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //CustomerTicketCategory
  getCustomerTicketCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketCategoryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerTicketFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Site Visit Completed
  getSitevisitCompleted: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSitevisitCompletedFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getItemForTravelBill: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTravelBillDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCountryCode: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //CRM Masters
  //project premium cost
  getCrmSitePremiumTypeDemo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSitePremiumType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getSitePremiumTypeExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getProjectPremiumCost: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectPremiumCostExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectPremiumCostFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectPremiumCostFilterPremiumType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Readiness Checklist
  getReadinessChecklist: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReadinessChecklistExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Site Investor
  getSiteInvestors: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteInvestorsExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Delay Reason
  getDelayReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteTDS: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  createSiteTDS: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  updateSiteTDS: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTdsSection: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteTDSExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteTDSDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteTDSFilterSection: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  // site cost
  getSiteCost: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteCostExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteCostFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Registration Cost
  getRegistrationCost: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRegistrationCostExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //sushil start
  getSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceCategoryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSourceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSubSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSubSourceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReasonExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //CRM Dimensions
  getDimension: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDimensionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Site Face
  getSiteFace: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteFaceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Lead Status
  getLeadStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadStatusExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Release Status
  getReleaseStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getReleaseStatusExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Site Status
  getSiteStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteStatusExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Cancellation Reason
  getCancellationReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCancellationReasonExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Block Reason
  getBlockReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBlockReasonExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Other Charges
  getOtherCharges: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOtherChargesExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  // CRM Project Other Charge Map
  getProjectOtherChargeMap: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectOtherChargeMapExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectOtherChargeDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectOtherChargeDetailFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Call status
  getCallStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Unqualified Reason
  getUnqualifiedReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUnqualifiedReasonExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // CRM Project Discount
  getSiteDiscount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteDiscountExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Lead Category
  getLeadCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeadCategoryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Lead Constraint
  getCrmLeadConstraint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmLeadConstraintExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Customer Contact Type
  getCustomerContactType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerContactTypeExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  // / Customer Contact
  getCustomerContact: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerContactExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerContactFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCustomerContactFilterContactType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCustomerFeedback: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCustomerFeedbackExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCustomerFeedbackFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  // Project Progress

  getProjectProgress: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectProgressExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectProgressFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectProgressDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //sushil end
  // clp start
  getConstructionLinkPayment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getConstructionLinkPaymentExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectClpPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectClpPlanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectClpPlanDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectClpPlanFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectClpPlanFilterBank: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectFromClpPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getBankFromClpPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMilestoneFromClpPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //clp payment schedule
  getClpPaymentSchedule: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getClpPaymentScheduleExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getClpPaymentScheduleFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getClpPaymentScheduleFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getClpPaymentScheduleDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getClpPaymentScheduleFilterSite: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getItemForProjectPlanClp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // clp demand
  getProjectForClpPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSiteForClpPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMilestoneForDemandNote: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getClpDemandNote: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getClpDemandNoteExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectForClpDemandNote: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getClpDemandNoteFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getClpDemandNoteDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentDelayReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentReceiptPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentDemandFilterMilestone: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMilestoneForDemandNoteReceived: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentDemandFilterCrmUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentDemandFilterSiteNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentDemandFilterSiteStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentScheduleFilterCrmUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // clp end
  //Company Resolution
  getProjectForCompanyResolution: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyResolution: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyResolutionDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyResolutionFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyResolutionFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //site authority
  getSiteForCompanyAuthorization: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getRepresentativeForCompanyAuthorization: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDirectorForCompanyAuthorization: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCompanyAuthorization: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCompanyAuthorizationFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getCompanyAuthorizationFilterRepresentative: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyAuthorizationFilterDirector: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyAuthorizationFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyAuthorizationDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDirectorForCompanyResolution: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};
const CRM_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CRM_ENQUIRY:
      return Object.assign({}, state, { getCrmEnquiry: payload });
    case GET_CRM_ENQUIRY_SOURCE:
      return Object.assign({}, state, { getCrmEnquirySource: payload });
    case GET_CUSTOMER_BUDGET:
      return Object.assign({}, state, { getCustomerBudget: payload });
    case GET_CRM_DIMENSION:
      return Object.assign({}, state, { getCrmDimension: payload });
    case GET_CUSTOMER_CONSTRUCTIONS_PLANNING:
      return Object.assign({}, state, {
        getCustomerConstructionPlanning: payload
      });
    case GET_CUSTOMER_PURCHASE_REASON:
      return Object.assign({}, state, { getCustomerPurchaseReason: payload });
    case GET_CRM_SITE_SOLD:
      return Object.assign({}, state, { getCrmSiteSold: payload });
    case GET_CRM_CUSTOMER_ENQUIRY:
      return Object.assign({}, state, { getCrmCustomerEnquiry: payload });
    case GET_CRM_ENQUIRY_PROFILE:
      return Object.assign({}, state, { getCrmEnquiryProfile: payload });
    case GET_CRM_ENQUIRY_PROFILE_EXPORT:
      return Object.assign({}, state, {
        getCrmEnquiryProfileExport: payload
      });
    case GET_SITE_VISIT_FEEDBACK_QUESTION:
      return Object.assign({}, state, {
        getSiteVisitFeedbackQuestion: payload
      });
    case GET_SITE_VISIT_FEEDBACK:
      return Object.assign({}, state, { getSiteVisitFeedback: payload });
    case GET_SITE_VISIT_FEEDBACK_EXPORT:
      return Object.assign({}, state, {
        getSiteVisitFeedbackExport: payload
      });
    case GET_SITE_VISIT_FEEDBACK_DETAIL:
      return Object.assign({}, state, {
        getSiteVisitFeedbackDetail: payload
      });
    case GET_CRM_BOOKING_ENQUIRY_PROFILE:
      return Object.assign({}, state, {
        getCrmBookingEnquiryProfile: payload
      });
    case GET_CRM_MEETING:
      return Object.assign({}, state, { getCrmMeeting: payload });

    // case GET_CRM_PROJECTS:
    //     return Object.assign({}, state, { getCrmProjects: payload });

    case GET_CRM_MEETING_CATEGORY:
      return Object.assign({}, state, { getCrmMeetingCategory: payload });

    case GET_CRM_MEETING_ATTENDEE:
      return Object.assign({}, state, { getCrmMeetingAttendee: payload });
    case GET_CRM_MEETING_DETAIL:
      return Object.assign({}, state, { getCrmMeetingDetail: payload });
    case GET_CRM_MEETING_EXPORT:
      return Object.assign({}, state, { getCrmMeetingExport: payload });
    case GET_CRM_MEETING_SOURCE:
      return Object.assign({}, state, { getCrmMeetingSource: payload });
    case GET_CRM_MEETING_CHANNEL_PARTNER_INFO:
      return Object.assign({}, state, {
        getCrmMeetingChannelPartnerInfo: payload
      });
    case GET_CRM_MEETING_CHANNEL_CLIENT_INFO:
      return Object.assign({}, state, { getCrmMeetingClientInfo: payload });
    case GET_CRM_MEETING_PREFERRED_LOCATION:
      return Object.assign({}, state, { getCrmPreferredLocation: payload });
    case GET_CRM_MEETING_PREFERRED_LOCATION_EXPORT:
      return Object.assign({}, state, {
        getCrmPreferredLocationExport: payload
      });
    case GET_CRM_MEETING_STM_INFO:
      return Object.assign({}, state, { getCrmMeetingStmInfo: payload });
    case GET_CRM_SOURCE_GROUP:
      return Object.assign({}, state, { getCrmSourceGroup: payload });

    case GET_CRM_SOURCE_GROUP_EXPORT:
      return Object.assign({}, state, { getCrmSourceGroupExport: payload });
    case GET_CRM_SOURCE_CATEGORY:
      return Object.assign({}, state, { getCrmSourceCategory: payload });
    case GET_CRM_SOURCE:
      return Object.assign({}, state, { getCrmSource: payload });
    case GET_CRM_ENQUIRY_STATUS:
      return Object.assign({}, state, { getCrmEnquiryStatus: payload });
    case GET_CRM_ENQUIRY_CATEGORY:
      return Object.assign({}, state, { getCrmEnquiryCategory: payload });
    case GET_CRM_ENQUIRY_CALL_STATUS:
      return Object.assign({}, state, { getCrmEnquiryCallStatus: payload });
    case GET_DIMENSION_MASTER:
      return Object.assign({}, state, { getCrmDimensionMaster: payload });

    case GET_RELEASE_STATUS:
      return Object.assign({}, state, { getCrmReleaseStatus: payload });
    case GET_CRM_SITE_PREMIUM_TYPE:
      return Object.assign({}, state, { getCrmSitePremiumType: payload });
    case GET_CRM_SITE_STATUS:
      return Object.assign({}, state, { getCrmSiteStatus: payload });
    case GET_SITE_INVESTOR:
      return Object.assign({}, state, { getCrmSiteInvestor: payload });
    case GET_BLOCK_REASON:
      return Object.assign({}, state, { getCrmBlockReason: payload });
    case GET_ENQUIRY_FOLLOW_STATUS:
      return Object.assign({}, state, { getEnquiryFollowStatus: payload });
    case GET_CRM_CHANNEL_PARTNER:
      return Object.assign({}, state, { getCrmMeetingChannelPartner: payload });
    case GET_CRM_CLIENT:
      return Object.assign({}, state, { getCrmMeetingClient: payload });
    case GET_CRM_STM:
      return Object.assign({}, state, { getCrmMeetingStm: payload });
    case GET_CRM_MEETING_FILTER_PROJECT:
      return Object.assign({}, state, { getCrmMeetingFilterProject: payload });
    case GET_CRM_MEETING_FILTER_HOSTED_BY:
      return Object.assign({}, state, { getCrmMeetingFilterHostedBy: payload });
    case GET_FELLOW_UP:
      return Object.assign({}, state, { getFellowUp: payload });
    case GET_FELLOW_UP_EXPORT:
      return Object.assign({}, state, { getFellowUpExport: payload });
    case GET_CRM_FOLLOW_UP_FILTER_ASSIGNED_TO:
      return Object.assign({}, state, {
        getCrmFollowUpFilterAssignedTo: payload
      });
    case GET_CRM_ENQUIRY_FOLLOW_UP_REASON:
      return Object.assign({}, state, {
        getCrmEnquiryFollowUpReason: payload
      });
    case GET_CRM_SITE_FACE:
      return Object.assign({}, state, {
        getCrmSiteFace: payload
      });
    case GET_CRM_CANCELLATION_REASON:
      return Object.assign({}, state, {
        getCrmCancellationReason: payload
      });

    //promotional activity
    case GET_PROMOTIONAL_ACTIVITY:
      return Object.assign({}, state, {
        getPromotionalActivity: payload
      });
    case GET_PROMOTIONAL_ACTIVITY_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPromotionalActivityFilterProject: payload
      });
    case CHECK_EXISTING_ENQUIRY:
      return Object.assign({}, state, {
        checkExistingEnquiry: payload
      });
    case GET_ACTIVITY_FOR_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getActivityForPromotionalLead: payload
      });
    case GET_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getPromotionalLead: payload
      });
    case GET_PROMOTIONAL_LEAD_EXPORT:
      return Object.assign({}, state, {
        getPromotionalLeadExport: payload
      });
    case GET_PROMOTIONAL_LEAD_FILTER_PROJECT:
      return Object.assign({}, state, {
        getPromotionalLeadFilterProject: payload
      });
    case GET_PROMOTIONAL_LEAD_FILTER_SOURCE:
      return Object.assign({}, state, {
        getPromotionalLeadFilterSource: payload
      });
    case GET_PROMOTIONAL_LEAD_FILTER_ACTIVITY:
      return Object.assign({}, state, {
        getPromotionalLeadFilterActivity: payload
      });
    case GET_SOURCE_FOR_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getSourceForPromotionLead: payload
      });
    case GET_SUB_SOURCE_FOR_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getSubSourceForPromotionalLead: payload
      });
    case GET_USER_FOR_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getUserForPromotionalLead: payload
      });
    case GET_ENQUIRY_DETAIL_FOR_PROMOTIONAL_LEAD:
      return Object.assign({}, state, {
        getEnquiryDetailForPromotionalLead: payload
      });
    //site visit
    case GET_LEAD_FOR_SITE_VISIT:
      return Object.assign({}, state, {
        getLeadForSiteVisit: payload
      });
    case GET_LEAD_DETAIL_FOR_SITE_VISIT:
      return Object.assign({}, state, {
        getLeadDetailForSiteVisit: payload
      });
    case GET_SITE_VISIT:
      return Object.assign({}, state, {
        getSitevisit: payload
      });
    case GET_EOI_PRICE:
      return Object.assign({}, state, {
        getEoiPrice: payload
      });

    case GET_EOI_PRICE_FILTER_PROJECT:
      return Object.assign({}, state, {
        getEoiPriceFilterProject: payload
      });

    case GET_EXPRESSION_OF_INTEREST:
      return Object.assign({}, state, {
        getExpressionOfInterest: payload
      });

    case GET_EXPRESSION_OF_INTEREST_EXPORT:
      return Object.assign({}, state, {
        getExpressionOfInterestExport: payload
      });

    case GET_EOI_PRICE_FILTER_DIMENSION:
      return Object.assign({}, state, {
        getEoiPriceFilterDimension: payload
      });
    case GET_CUSTOMER_INFO:
      return Object.assign({}, state, {
        getCustomerInfo: payload
      });
    case GET_EXPRESSION_OF_INTEREST_DETAIL:
      return Object.assign({}, state, {
        getExpressionOfInterestDetail: payload
      });
    case GET_EXPRESSION_OF_INTEREST_FILTER_PROJECT:
      return Object.assign({}, state, {
        getExpressionOfInterestFilterProject: payload
      });
    case GET_EOI_PRICE_DETAIL:
      return Object.assign({}, state, {
        getEoiPriceDetail: payload
      });
    case GET_COMPANY_FOR_CRM_PROJECT:
      return Object.assign({}, state, {
        getCompanyForCrmProject: payload
      });
    case GET_EOI_PAYMENT_DETAIL:
      return Object.assign({}, state, {
        getEOIPaymentDetail: payload
      });
    case GET_SITE_FACING:
      return Object.assign({}, state, {
        getSiteFacing: payload
      });
    // CustomerTicket
    case GET_CATEGORY_FOR_TICKET:
      return Object.assign({}, state, {
        getCategoryForTicket: payload
      });

    case GET_CUSTOMER_TICKET:
      return Object.assign({}, state, {
        getCustomerTicket: payload
      });
    case GET_CUSTOMER_TICKET_EXPORT:
      return Object.assign({}, state, {
        getCustomerTicketExport: payload
      });
    case GET_CUSTOMER_TICKET_FOR_SITE:
      return Object.assign({}, state, {
        getCustomerTicketForSite: payload
      });
    case GET_USER_TICKET_FILTER:
      return Object.assign({}, state, {
        getCustomerTicketFilterAssignedTo: payload
      });
    case GET_CUSTOMER_TICKET_FOR_ASSINGNED_USER:
      return Object.assign({}, state, {
        getCustomerTicketForAssignedUser: payload
      });
    case GET_TICKET_FOLLOW_UP:
      return Object.assign({}, state, {
        getTicketFollowUp: payload
      });
    case GET_CUSTOMER_TICKET_DETAIL:
      return Object.assign({}, state, {
        getCustomerTicketDetail: payload
      });
    case GET_PROJECT_TICKET_FILTER:
      return Object.assign({}, state, {
        getCustomerTicketFilterProject: payload
      });
    case GET_CUSTOMER_TICKET_STATUS:
      return Object.assign({}, state, {
        getCustomerTicketStatus: payload
      });

    //CustomerTicketCategory
    case GET_CUSTOMER_TICKET_CATEGORY:
      return Object.assign({}, state, {
        getCustomerTicketCategory: payload
      });
    case GET_CUSTOMER_TICKET_CATEGORY_EXPORT:
      return Object.assign({}, state, {
        getCustomerTicketCategoryExport: payload
      });
    case GET_CUSTOMER_TICKET_FILTER_STATUS:
      return Object.assign({}, state, {
        getCustomerTicketFilterStatus: payload
      });

    // Site Visit Completed
    case GET_SITE_VISIT_COMPLETED:
      return Object.assign({}, state, {
        getSitevisitCompleted: payload
      });
    case GET_SITE_VISIT_COMPLETED_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSitevisitCompletedFilterProject: payload
      });
    case GET_ITEM_FOR_TRAVEL_BILL:
      return Object.assign({}, state, {
        getItemForTravelBill: payload
      });
    case GET_TRAVEL_BILL_DETAILS:
      return Object.assign({}, state, {
        getTravelBillDetail: payload
      });
    case GET_COUNTRY_CODE:
      return Object.assign({}, state, {
        getCountryCode: payload
      });
    //CRM Masters
    case GET_SITE_PREMIUM_TYPE:
      return Object.assign({}, state, { getSitePremiumType: payload });
    case GET_SITE_PREMIUM_TYPE_EXPORT:
      return Object.assign({}, state, { getSitePremiumTypeExport: payload });
    case GET_PROJECT_PREMIUM_COST:
      return Object.assign({}, state, { getProjectPremiumCost: payload });

    case GET_PROJECT_PREMIUM_COST_EXPORT:
      return Object.assign({}, state, { getProjectPremiumCostExport: payload });
    case GET_PROJECT_PREMIUM_COST_FILTER_PROJECT:
      return Object.assign({}, state, {
        getProjectPremiumCostFilterProject: payload
      });

    case GET_PROJECT_PREMIUM_COST_FILTER_PREMIUM_TYPE:
      return Object.assign({}, state, {
        getProjectPremiumCostFilterPremiumType: payload
      });
    case GET_READINESS_CHECKLIST:
      return Object.assign({}, state, { getReadinessChecklist: payload });

    case GET_READINESS_CHECKLIST_EXPORT:
      return Object.assign({}, state, { getReadinessChecklistExport: payload });
    //Site Investor
    case GET_SITE_INVESTORS:
      return Object.assign({}, state, {
        getSiteInvestors: payload
      });

    case GET_SITE_INVESTORS_EXPORT:
      return Object.assign({}, state, {
        getSiteInvestorsExport: payload
      });

    //Delay Reason
    case GET_DELAY_REASON:
      return Object.assign({}, state, {
        getDelayReason: payload
      });

    case GET_DELAY_REASON_EXPORT:
      return Object.assign({}, state, {
        getDelayReasonExport: payload
      });
    //Site TDS
    case GET_SITE_TDS:
      return Object.assign({}, state, {
        getSiteTDS: payload
      });
    case GET_SITE_TDS_EXPORT:
      return Object.assign({}, state, {
        getSiteTDSExport: payload
      });
    case GET_SITE_TDS_DETAIL:
      return Object.assign({}, state, {
        getSiteTDSDetail: payload
      });
    case GET_SITE_TDS_FILTER_SECTION:
      return Object.assign({}, state, {
        getSiteTDSFilterSection: payload
      });
    case CREATE_SITE_TDS:
      return Object.assign({}, state, {
        createSiteTDS: payload
      });
    case UPDATE_SITE_TDS:
      return Object.assign({}, state, {
        updateSiteTDS: payload
      });
    case GET_TDS_SECTION:
      return Object.assign({}, state, {
        getTdsSection: payload
      });
    // site cost
    case GET_SITE_COST:
      return Object.assign({}, state, {
        getSiteCost: payload
      });
    case GET_SITE_COST_EXPORT:
      return Object.assign({}, state, {
        getSiteCostExport: payload
      });
    case GET_SITE_COST_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSiteCostFilterProject: payload
      });
    //Registration Cost
    case GET_REGISTRATION_COST:
      return Object.assign({}, state, {
        getRegistrationCost: payload
      });
    case GET_REGISTRATION_COST_EXPORT:
      return Object.assign({}, state, {
        getRegistrationCostExport: payload
      });
    //sushil start
    // CRM Category
    case GET_SOURCE_CATEGORY:
      return Object.assign({}, state, { getSourceCategory: payload });
    case GET_SOURCE_CATEGORY_EXPORT:
      return Object.assign({}, state, { getSourceCategoryExport: payload });
    // CRM Source
    case GET_SOURCE:
      return Object.assign({}, state, { getSource: payload });
    case GET_SOURCE_EXPORT:
      return Object.assign({}, state, { getSourceExport: payload });
    // CRM Sub Source
    case GET_SUB_SOURCE:
      return Object.assign({}, state, { getSubSource: payload });
    case GET_SUB_SOURCE_EXPORT:
      return Object.assign({}, state, { getSubSourceExport: payload });
    // CRM Reason
    case GET_REASON:
      return Object.assign({}, state, { getReason: payload });
    case GET_REASON_EXPORT:
      return Object.assign({}, state, { getReasonExport: payload });
    // CRM Dimensions
    case GET_DIMENSION:
      return Object.assign({}, state, { getDimension: payload });
    case GET_DIMENSION_EXPORT:
      return Object.assign({}, state, { getDimensionExport: payload });
    // CRM site face
    case GET_SITE_FACE:
      return Object.assign({}, state, {
        getSiteFace: payload
      });
    case GET_SITE_FACE_EXPORT:
      return Object.assign({}, state, {
        getSiteFaceExport: payload
      });
    // CRM Lead Status
    case GET_LEAD_STATUS:
      return Object.assign({}, state, { getLeadStatus: payload });
    case GET_LEAD_STATUS_EXPORT:
      return Object.assign({}, state, { getLeadStatusExport: payload });
    // Crm Release Status
    case GET_RELEASE_STATUS_NEW:
      return Object.assign({}, state, { getReleaseStatus: payload });
    case GET_RELEASE_STATUS_NEW_EXPORT:
      return Object.assign({}, state, { getReleaseStatusExport: payload });
    // Crm Site Status
    case GET_SITE_STATUS:
      return Object.assign({}, state, {
        getSiteStatus: payload
      });
    case GET_SITE_STATUS_EXPORT:
      return Object.assign({}, state, {
        getSiteStatusExport: payload
      });
    // Crm Cancellation Reason
    case GET_CANCELLATION_REASON:
      return Object.assign({}, state, {
        getCancellationReason: payload
      });
    case GET_CANCELLATION_REASON_EXPORT:
      return Object.assign({}, state, {
        getCancellationReasonExport: payload
      });
    // CRM Block Reason
    case GET_BLOCK_REASON_NEW:
      return Object.assign({}, state, { getBlockReason: payload });
    case GET_BLOCK_REASON_NEW_EXPORT:
      return Object.assign({}, state, { getBlockReasonExport: payload });
    // CRM Other Charges
    case GET_OTHER_CHARGES:
      return Object.assign({}, state, { getOtherCharges: payload });
    case GET_OTHER_CHARGES_EXPORT:
      return Object.assign({}, state, { getOtherChargesExport: payload });
    // CRM Project Other Charge Map
    case GET_PROJECT_OTHER_CHARGE_MAP:
      return Object.assign({}, state, { getProjectOtherChargeMap: payload });
    case GET_PROJECT_OTHER_CHARGE_MAP_EXPORT:
      return Object.assign({}, state, {
        getProjectOtherChargeMapExport: payload
      });
    case GET_PROJECT_OTHER_CHARGE_DETAIL:
      return Object.assign({}, state, { getProjectOtherChargeDetail: payload });
    case GET_PROJECT_OTHER_CHARGE_DETAIL_FILTER_PROJECT:
      return Object.assign({}, state, {
        getProjectOtherChargeDetailFilterProject: payload
      });

    // CRM Call status
    case GET_CALL_STATUS:
      return Object.assign({}, state, { getCallStatus: payload });
    case GET_CALL_STATUS_EXPORT:
      return Object.assign({}, state, { getCallStatusExport: payload });
    // // CRM Call status
    // case GET_CALL_STATUS:
    //   return Object.assign({}, state, { getCallStatus: payload });
    // CRM Unqaulified Reason
    case GET_UNQUALIFIED_REASON:
      return Object.assign({}, state, { getUnqualifiedReason: payload });
    case GET_UNQUALIFIED_REASON_EXPORT:
      return Object.assign({}, state, { getUnqualifiedReasonExport: payload });
    // CRM Project Discount
    case GET_SITE_DISCOUNT:
      return Object.assign({}, state, { getSiteDiscount: payload });
    case GET_SITE_DISCOUNT_EXPORT:
      return Object.assign({}, state, { getSiteDiscountExport: payload });
    // Lead Category
    case GET_LEAD_CATEGORY:
      return Object.assign({}, state, {
        getLeadCategory: payload
      });
    case GET_LEAD_CATEGORY_EXPORT:
      return Object.assign({}, state, {
        getLeadCategoryExport: payload
      });
    // Lead Constraint
    case GET_CRM_LEAD_CONSTRAINT:
      return Object.assign({}, state, {
        getCrmLeadConstraint: payload
      });
    case GET_CRM_LEAD_CONSTRAINT_EXPORT:
      return Object.assign({}, state, {
        getCrmLeadConstraintExport: payload
      });
    // Customer Contact Type
    case GET_CUSTOMER_CONTACT_TYPE:
      return Object.assign({}, state, {
        getCustomerContactType: payload
      });
    case GET_CUSTOMER_CONTACT_TYPE_EXPORT:
      return Object.assign({}, state, {
        getCustomerContactTypeExport: payload
      });

    // Customer Contact
    case GET_CUSTOMER_CONTACT:
      return Object.assign({}, state, {
        getCustomerContact: payload
      });
    case GET_CUSTOMER_CONTACT_EXPORT:
      return Object.assign({}, state, {
        getCustomerContactExport: payload
      });
    case GET_CUSTOMER_CONTACT_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCustomerContactFilterProject: payload
      });
    case GET_CUSTOMER_CONTACT_FILTER_CONTACT_TYPE:
      return Object.assign({}, state, {
        getCustomerContactFilterContactType: payload
      });

    // Customer Feedback

    case GET_CUSTOMER_FEEDBACK:
      return Object.assign({}, state, {
        getCustomerFeedback: payload
      });
    case GET_CUSTOMER_FEEDBACK_EXPORT:
      return Object.assign({}, state, {
        getCustomerFeedbackExport: payload
      });
    case GET_CUSTOMER_FEEDBACK_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCustomerFeedbackFilterProject: payload
      });

    // Project Progress

    case GET_PROJECT_PROGRESS:
      return Object.assign({}, state, {
        getProjectProgress: payload
      });
    case GET_PROJECT_PROGRESS_EXPORT:
      return Object.assign({}, state, {
        getProjectProgressExport: payload
      });
    case GET_PROJECT_PROGRESS_FILTER_PROJECT:
      return Object.assign({}, state, {
        getProjectProgressFilterProject: payload
      });
    case GET_PROJECT_PROGRESS_DETAIL:
      return Object.assign({}, state, {
        getProjectProgressDetail: payload
      });

    //sushil end
    // clp dstart
    case GET_CONSTRUCTION_LINK_PAYMENT:
      return Object.assign({}, state, { getConstructionLinkPayment: payload });
    case GET_CONSTRUCTION_LINK_PAYMENT_EXPORT:
      return Object.assign({}, state, {
        getConstructionLinkPaymentExport: payload
      });
    case GET_PROJECT_CLP_PLAN:
      return Object.assign({}, state, {
        getProjectClpPlan: payload
      });
    case GET_PROJECT_CLP_PLAN_EXPORT:
      return Object.assign({}, state, {
        getProjectClpPlanExport: payload
      });
    case GET_PROJECT_CLP_PLAN_DETAILS:
      return Object.assign({}, state, {
        getProjectClpPlanDetail: payload
      });
    case GET_PROJECT_CLP_PLAN_FILTER_PROJECT:
      return Object.assign({}, state, {
        getProjectClpPlanFilterProject: payload
      });
    case GET_PROJECT_CLP_PLAN_FILTER_BANK:
      return Object.assign({}, state, {
        getProjectClpPlanFilterBank: payload
      });

    case GET_PROJECT_FROM_CLP_PLAN:
      return Object.assign({}, state, {
        getProjectFromClpPlan: payload
      });
    case GET_BANK_FROM_CLP_PLAN:
      return Object.assign({}, state, {
        getBankFromClpPlan: payload
      });
    case GET_MILESTONE_FORM_CLP_PLAN:
      return Object.assign({}, state, {
        getMilestoneFromClpPlan: payload
      });
    //clp payment schedule
    case GET_CLP_PAYMENT_SCHEDULE:
      return Object.assign({}, state, {
        getClpPaymentSchedule: payload
      });
    case GET_CLP_PAYMENT_SCHEDULE_EXPORT:
      return Object.assign({}, state, {
        getClpPaymentScheduleExport: payload
      });
    case GET_CLP_PAYMENT_SCHEDULE_FILTER_PROJECT:
      return Object.assign({}, state, {
        getClpPaymentScheduleFilterProject: payload
      });
    case GET_CLP_PAYMENT_SCHEDULE_FILTER_STATUS:
      return Object.assign({}, state, {
        getClpPaymentScheduleFilterStatus: payload
      });
    case GET_CLP_PAYMENT_SCHUDULE_DETAIL:
      return Object.assign({}, state, {
        getClpPaymentScheduleDetail: payload
      });
    case GET_CLP_PAYMENT_SCHEDULE_FILTER_SITE:
      return Object.assign({}, state, {
        getClpPaymentScheduleFilterSite: payload
      });
    case GET_ITEM_FOR_PROJECR_PLAN_CLP:
      return Object.assign({}, state, {
        getItemForProjectPlanClp: payload
      });
    // clp demand
    case GET_PROJECT_FOR_CLP_PLAN:
      return Object.assign({}, state, {
        getProjectForClpPlan: payload
      });
    case GET_SITE_FOR_CLP_PLAN:
      return Object.assign({}, state, {
        getSiteForClpPlan: payload
      });
    case GET_MILESTONE_FOR_DEMAND_NOTE:
      return Object.assign({}, state, {
        getMilestoneForDemandNote: payload
      });
    case GET_CLP_DEMAND_NOTE:
      return Object.assign({}, state, {
        getClpDemandNote: payload
      });
    case GET_CLP_DEMAND_NOTE_EXPORT:
      return Object.assign({}, state, {
        getClpDemandNoteExport: payload
      });
    case GET_PROJECT_FOR_CLP_DEMAND_NOTE:
      return Object.assign({}, state, {
        getProjectForClpDemandNote: payload
      });
    case GET_CLP_DEMAND_NOTE_FILTER_STATUS:
      return Object.assign({}, state, {
        getClpDemandNoteFilterStatus: payload
      });
    case GET_CLP_DEMAND_NOTE_DETAILS:
      return Object.assign({}, state, {
        getClpDemandNoteDetail: payload
      });
    case GET_PAYMENT_DELAY_REASON:
      return Object.assign({}, state, {
        getPaymentDelayReason: payload
      });
    case GET_PAYMENT_RECEIPT_PRINT:
      return Object.assign({}, state, {
        getPaymentReceiptPrint: payload
      });
    case GET_PAYMENT_DEMAND_FILTER_MILESTONE:
      return Object.assign({}, state, {
        getPaymentDemandFilterMilestone: payload
      });
    case GET_MILESTONE_FOR_DEMAND_NOTE_RECEIVED:
      return Object.assign({}, state, {
        getMilestoneForDemandNoteReceived: payload
      });
    case GET_PAYMENT_DEMAND_FILTER_CRM_USER:
      return Object.assign({}, state, {
        getPaymentDemandFilterCrmUser: payload
      });
    case GET_PAYMENT_DEMAND_FILTER_SITE_NUMBER:
      return Object.assign({}, state, {
        getPaymentDemandFilterSiteNumber: payload
      });
    case GET_PAYMENT_DEMAND_FILTER_SITE_STATUS:
      return Object.assign({}, state, {
        getPaymentDemandFilterSiteStatus: payload
      });
    case GET_PAYMENT_SCHEDULE_FILTER_CRM_USER:
      return Object.assign({}, state, {
        getPaymentScheduleFilterCrmUser: payload
      });
    // clp end
    //Company Resolution
    case GET_PROJECT_FOR_COMPANY_RESOLUTION:
      return Object.assign({}, state, {
        getProjectForCompanyResolution: payload
      });
    case GET_COMPANY_RESOLUTION:
      return Object.assign({}, state, {
        getCompanyResolution: payload
      });
    case GET_COMPANY_RESOLUTION_DETAIL:
      return Object.assign({}, state, {
        getCompanyResolutionDetail: payload
      });
    case GET_COMPANY_RESOLUTION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCompanyResolutionFilterProject: payload
      });

    case GET_COMPANY_RESOLUTION_FILTER_COMPANY:
      return Object.assign({}, state, {
        getCompanyResolutionFilterCompany: payload
      });

    //site authority
    case GET_SITE_FOR_COMPANY_AUTHORIZATION:
      return Object.assign({}, state, {
        getSiteForCompanyAuthorization: payload
      });
    case GET_REPRESENTATIVE_FOR_COMPANY_AUTHORIZATION:
      return Object.assign({}, state, {
        getRepresentativeForCompanyAuthorization: payload
      });
    case GET_DIRECTOR_FOR_COMPANY_AUTHORIZATION:
      return Object.assign({}, state, {
        getDirectorForCompanyAuthorization: payload
      });
    case GET_COMPANY_AUTHORIZATION:
      return Object.assign({}, state, {
        getCompanyAuthorization: payload
      });
    case GET_COMPANY_AUTHORIZATION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getCompanyAuthorizationFilterProject: payload
      });
    case GET_COMPANY_AUTHORIZATION_FILTER_REPRESENTATIVE:
      return Object.assign({}, state, {
        getCompanyAuthorizationFilterRepresentative: payload
      });
    case GET_COMPANY_AUTHORIZATION_FILTER_DIRECTOR:
      return Object.assign({}, state, {
        getCompanyAuthorizationFilterDirector: payload
      });
    case GET_COMPANY_AUTHORIZATION_FILTER_COMPANY:
      return Object.assign({}, state, {
        getCompanyAuthorizationFilterCompany: payload
      });
    case GET_COMPANY_AUTHORIZATION_DETAIL:
      return Object.assign({}, state, {
        getCompanyAuthorizationDetail: payload
      });

    case GET_DIRECTOR_FOR_COMPANY_RESOLUTION:
      return Object.assign({}, state, {
        getDirectorForCompanyResolution: payload
      });
    default:
      return state;
  }
};
export default CRM_reducer;
